import React, { useState, useMemo } from "react";
import {
  Container,
  Grid,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import PageHeader from "../components/PageHeader";

import stationBackground from '../../assets/centrum_assets/design/stations/stationBG.png';



import StationHeaderFilter from "../components/StationHeaderFilter";
import StationCardItem from "../components/StationCardItem";
import Socialmedia from "../components/Socialmedia";
import LinesDecor from "../components/LinesDecor";

import { useStations } from "../../hooks/useStations"; 

export default function LatestStationOpenings() {
  const [visibleCards, setVisibleCards] = useState(6);
  const [showLessVisible, setShowLessVisible] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState("All");

  const { data: stations = [], isLoading: loading } = useStations();

  const provinceOptions = useMemo(() => {
    const allProvinces = stations
      .map((s) => s.province)
      .filter((p) => p !== null && p !== undefined && p !== "");
    const uniqueProvinces = Array.from(new Set(allProvinces)).sort();
    return ["All", ...uniqueProvinces];
  }, [stations]);

  const filteredStations = stations.filter((station) => {
    if (selectedProvince === "All") return true;
    return station.province === selectedProvince;
  });

  const handleFilterChange = (event) => {
    setSelectedProvince(event.target.value);
    setVisibleCards(6);
    setShowLessVisible(false);
  };

  const handleShowMore = () => {
    setVisibleCards((prev) => prev + 3);
    setShowLessVisible(true);
  };

  const handleShowLess = () => {
    setVisibleCards(6);
    setShowLessVisible(false);
  };

  return (
    <>
      <PageHeader title="STATIONS" />
      <Box sx={{ backgroundImage: `url(${stationBackground})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <Container maxWidth="lg" sx={{ py: 5, px: 4, mt: {lg:10, sm: 5},}}>
        <StationHeaderFilter
          title="LATEST STATION OPENINGS"
          provinces={provinceOptions}
          selectedProvince={selectedProvince}
          onFilterChange={handleFilterChange}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress sx={{ color: "#009fb6" }} />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {filteredStations.length > 0 ? (
              filteredStations.slice(0, visibleCards).map((station, index) => (
                <Grid item xs={12} sm={6} md={4} key={station.id || index}>
                  <StationCardItem 
                    station={station} 
                    filteredStations={filteredStations} 
                    currentFilter={selectedProvince}
                  />
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Box textAlign="center" py={10}>
                  <Typography variant="h6" color="text.secondary">
                    No stations found in this province.
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        )}

        {!loading && filteredStations.length > 6 && (
          <Box 
            textAlign="center" 
            mt={5} 
            display="flex" 
            justifyContent="center" 
            gap={2}
            
            sx={{ position: 'relative', zIndex: 20 }}
        
          >
            {visibleCards < filteredStations.length && (
              <Button
                onClick={handleShowMore}
                variant="contained"
                sx={{
                      backgroundColor: "#00bbd4",
                      px: 3,
                      borderRadius: "40px",
                      letterSpacing: 2,
                      fontSize: '1.4rem',
                      fontWeight: 550,
                      "&:hover": { backgroundColor: "#009fb6" },
                }}
              >
                Show More
              </Button>
            )}
            {showLessVisible && (
              <Button
                onClick={handleShowLess}
                variant="outlined"
                sx={{
                  borderColor: "#00bbd4",
                  color: "#fff",
                  backgroundColor: "#00bbd4",
                  px: 3,
                  borderRadius: "40px",
                  letterSpacing: 2,
                  fontSize: '1.4rem',
                  fontWeight: 550,
                  "&:hover": { backgroundColor: "#009fb6" },
                }}
              >
                Show Less
              </Button>
            )}
          </Box>
        )}
      </Container>
      </Box>
      
       <Socialmedia />

       <Box sx={{ position: "Relative", width: "100%", mt: 5 }}>
          <LinesDecor greenMt={{ lg: -10, md: -6, xs: -4 }} blueMt={{ lg: -5 }} />
       </Box>

    </>
  );
}